// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-step{color:var(--font-color)}.checkout-step.disabled{opacity:.5}", "",{"version":3,"sources":["webpack://./src/app/vue/checkout/checkout-step.vue"],"names":[],"mappings":"AACA,eACE,uBAAF,CAEE,wBACE,UAAJ","sourcesContent":["\n.checkout-step {\n  color: var(--font-color);\n\n  &.disabled {\n    opacity: .5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
